{
  "name": "bueno-frontend",
  "version": "2.0.6",
  "buildTimestamp": "2026-10-23T11:58:25.348Z",
  "scripts": {
    "ng": "ng",
    "start": "npm run generate:version && ng serve",
    "build": "npm run generate:version && ng build",
    "build:production": "npm run generate:version && ng build --configuration production",
    "build:sandbox": "npm run generate:version && ng build --configuration sandbox",
    "lint": "ng lint",
    "lint-fix": "ng lint --fix",
    "e2e": "ng e2e",
    "watch": "npm run generate:version && ng build --watch --configuration development",
    "test": "ng test",
    "build-bulma": "sass --load-path=node_modules src/styles/bulma/custom-bulma-styles.scss src/bulma/custom-bulma-styles.css",
    "format": "prettier --write \"src/**/*.{ts,html,css,scss}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,css,scss}\"",
    "generate:version": "node tools/write-app-version.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular-magic/ngx-gp-autocomplete": "^2.0.2",
    "@angular-material-extensions/password-strength": "^16.0.0",
    "@angular-material-extensions/select-country": "^17.0.0",
    "@angular/animations": "^20.3.2",
    "@angular/cdk": "^20.2.7",
    "@angular/common": "^20.3.2",
    "@angular/compiler": "^20.3.2",
    "@angular/core": "^20.3.2",
    "@angular/forms": "^20.3.2",
    "@angular/google-maps": "^20.2.7",
    "@angular/material": "^20.2.7",
    "@angular/platform-browser": "^20.3.2",
    "@angular/platform-browser-dynamic": "^20.3.2",
    "@angular/router": "^20.3.2",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.1.0",
    "@fortawesome/free-brands-svg-icons": "^7.1.0",
    "@fortawesome/free-regular-svg-icons": "^7.1.0",
    "@fortawesome/free-solid-svg-icons": "^7.1.0",
    "@fortawesome/pro-duotone-svg-icons": "^7.1.0",
    "@fortawesome/pro-light-svg-icons": "^7.1.0",
    "@fortawesome/pro-regular-svg-icons": "^7.1.0",
    "@fortawesome/pro-solid-svg-icons": "^7.1.0",
    "@fortawesome/pro-thin-svg-icons": "^7.1.0",
    "@fortawesome/sharp-solid-svg-icons": "^7.0.1",
    "@googlemaps/js-api-loader": "^2.0.1",
    "@maskito/angular": "^3.11.1",
    "@maskito/core": "^3.11.1",
    "@maskito/kit": "^3.11.1",
    "@ng-icons/core": "^32.1.0",
    "@ng-icons/heroicons": "^32.1.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular-ivy": "^7.120.4",
    "angular-code-input": "^2.0.0",
    "angular-iban": "^20.0.0",
    "angular-oauth2-oidc": "^20.0.2",
    "angular-oauth2-oidc-jwks": "^20.0.0",
    "bootstrap": "^5.3.8",
    "bulma": "^1.0.4",
    "bulma-block-list": "^1.1.0",
    "bulma-floating-button": "^1.0.3",
    "bulma-list": "^3.0.0",
    "bulma-o-steps": "^1.1.0",
    "firebase": "^12.8.0",
    "html2canvas": "^1.4.1",
    "iban": "^0.0.14",
    "libphonenumber-js": "^1.12.23",
    "lottie-web": "^5.13.0",
    "luxon": "^3.7.2",
    "mat-tel-input": "^19.0.5-0",
    "ng-recaptcha-2": "^16.0.1",
    "ngx-cookie-service": "^20.1.0",
    "ngx-device-detector": "^10.1.0",
    "ngx-extended-pdf-viewer": "^25.5.1",
    "ngx-infinite-scroll": "^20.0.0",
    "ngx-lottie": "^20.0.0",
    "ngx-mask": "^20.0.3",
    "ngx-masonry": "^14.0.1",
    "ngx-mat-timepicker": "^20.0.1",
    "ngx-material-timepicker": "^13.1.1",
    "postcode-validator": "^3.10.5",
    "rxjs": "~7.8.2",
    "sass": "^1.93.2",
    "svg-country-flags": "^1.2.10",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "optionalDependencies": {
    "@esbuild/linux-x64": "0.25.10"
  },
  "overrides": {
    "@angular-material-extensions/password-strength": {
      "@angular/common": "^17.3.4",
      "@angular/cdk": "^17.3.4",
      "@angular/core": "^17.3.4",
      "@angular/forms": "^17.3.4",
      "@angular/material": "^17.3.4"
    }
  },
  "devDependencies": {
    "@angular-eslint/builder": "20.3.0",
    "@angular-eslint/eslint-plugin": "20.3.0",
    "@angular-eslint/eslint-plugin-template": "20.3.0",
    "@angular-eslint/schematics": "20.3.0",
    "@angular-eslint/template-parser": "20.3.0",
    "@angular/build": "^20.3.3",
    "@angular/cli": "~20.3.3",
    "@angular/compiler-cli": "^20.3.2",
    "@angular/localize": "^20.3.2",
    "@types/google.maps": "^3.65.2",
    "@types/iban": "^0.0.35",
    "@types/jasmine": "~5.1.9",
    "@types/luxon": "^3.7.1",
    "@typescript-eslint/eslint-plugin": "8.45.0",
    "@typescript-eslint/parser": "8.45.0",
    "eslint": "^9.36.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.4",
    "jasmine-core": "~5.11.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.6.2",
    "prettier-plugin-organize-imports": "^4.3.0",
    "typescript": "~5.9.3"
  }
}
